'use client';

import type {
  ProductDetailData,
  VariantsEntity,
} from '@eliadmin/core/src/api/products/types/product-types';

import { Paragraph } from '../../../ui/paragraph';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductTabsDescription({
  product,
  selectedVariant,
}: {
  product: ProductDetailData;
  selectedVariant?: VariantsEntity;
}) {
  const desiredObject = product.variants?.length ? selectedVariant : product;

  const description = desiredObject?.description;

  return (
    <Paragraph
      className={cn('w-full font-medium', 'ea-product-tabs__description-paragraph')}
      innerHtml={description}
      size="lg"
      color="black"
    />
  );
}
